import { render } from "./CompanyNumbersView.vue?vue&type=template&id=faefdcd2"
import script from "./CompanyNumbersView.vue?vue&type=script&lang=js"
export * from "./CompanyNumbersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__